// THIS FILE IS BEING DEPRECATED.
// PLEASE DO NOT PUT ANYTHING ELSE IN HERE.

import moment from "moment";
import _ from "lodash";

export const validateEmail = (email) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);

export const isEmptyObject = (obj) =>
  Object.entries(obj).length === 0 && obj.constructor === Object;

export const assertObjectEquality = (obj1, obj2) => JSON.stringify(obj1) === JSON.stringify(obj2);

export function fromEntries(iterable) {
  return [...iterable].reduce((obj, { 0: key, 1: val }) => Object.assign(obj, { [key]: val }), {});
}

/*
  This method is used to compare API results to check whether or not we should update the
  UI. You allow-list the data you actually want compared. Returns true if the objects
  are functionally identical.
 */
export const compareTwoStateData = (oldData = {}, newData = {}, keys = []) =>
  keys.reduce(
    (bool, key) => bool && _.isEqual(oldData[key], newData[key]),
    true,
  );

export const validateNumericValue = (value) => !Number.isNaN(parseInt(value, 10));

export const hexToRgba = (hex, opacity = 100) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) {
    return "rbga(0,0,0,1.0)";
  }
  const r = parseInt(result[1], 16);
  const g = parseInt(result[2], 16);
  const b = parseInt(result[3], 16);
  const a = parseFloat(opacity / 100);
  return `rgba(${r}, ${g}, ${b}, ${a})`;
};

export const startStopTimeString = (start, stop) => {
  if (!start || !stop) return "";
  const minutesDiff = calculateDurationInMins(start, stop);
  return `${moment(start).format("LT")} / ${moment(stop).format("LT")} (${minutesDiff})`;
};

export const calculateDurationInMins = (start, stop) => {
  const startTime = moment(start);
  const stopTime = stop ? moment(stop) : moment(); // If the trip or reservation is currently ongoing, set stop time to now
  const diffInSeconds = moment.duration(stopTime.diff(startTime)).as("seconds");
  const diffInMinutes = (diffInSeconds % 60 > 0 ? 1 : 0) + Math.floor(diffInSeconds / 60);
  return `${diffInMinutes} min`;
};

export const responsiveSize = (frameSize) =>
  window.innerWidth > 958
    ? window.innerWidth * 0.1 * frameSize
    : window.innerWidth * 0.35 * frameSize;

export const recParseObjectForForm = (obj) => {
  Object.keys(obj).forEach((k) => {
    if (typeof obj[k] === "boolean") return obj[k];
    if (obj[k] !== 0 && !obj[k]) obj[k] = "";
    if (typeof obj[k] === "object") return recParseObjectForForm(obj[k]);
    obj[k] = String(obj[k]);
    return obj[k];
  });
  return obj;
};

export const debounce = (callback, timeout = 300) => {
  let timer;

  return (...args) => {
    clearTimeout(timer);

    timer = setTimeout(() => {
      // eslint-disable-next-line babel/no-invalid-this
      callback.apply(this, args);
    }, timeout);
  };
};
